module.exports = __webpack_public_path__ + "img/coil.d090f424.jpg";